import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'truncate' })
export class TruncatePipe implements PipeTransform {
  transform(value: string, length?: number): string {
    const limit = length ? length : 30;
    return value && value.length > limit ? `${value.substring(0, limit)}...` : value;
  }
}
